import { LitElement, html } from 'lit'
import './feature-card.js'

class FeaturesSection extends LitElement {
    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    static properties = {
        features: { type: Array }
    }

    constructor() {
        super()
        this.features = [
            {
                icon: 'fa-solid fa-robot',
                title: 'Intelligent Automation',
                description: 'Our AI learns your workflow patterns and automates repetitive tasks with remarkable accuracy, saving you hours every day.'
            },
            {
                icon: 'fa-solid fa-puzzle-piece',
                title: 'Seamless Integration',
                description: 'Connect with over 1000+ popular tools and platforms. JigsAI fits perfectly into your existing workflow ecosystem.'
            },
            {
                icon: 'fa-solid fa-chart-line',
                title: 'Performance Analytics',
                description: 'Track productivity gains with detailed analytics and insights. See exactly how much time and effort JigsAI saves you.'
            },
            {
                icon: 'fa-solid fa-users',
                title: 'Team Collaboration',
                description: 'Share automated workflows with your team. Scale efficiency across your entire organization with collaborative features.'
            },
            {
                icon: 'fa-solid fa-gears',
                title: 'Custom Workflows',
                description: 'Build sophisticated automation workflows with our intuitive drag-and-drop interface. No coding required.'
            },
            {
                icon: 'fa-solid fa-cloud-check',
                title: 'Cloud-Native',
                description: 'Access your automations anywhere, anytime. Our cloud infrastructure ensures 99.9% uptime and lightning-fast performance.'
            }
        ]
    }

    render() {
        return html`
            <section class="section-padding bg-white dark:bg-gray-900">
                <div class="container-custom">
                    <!-- Section Header -->
                    <div class="text-center mb-16">
                        <h2 class="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
                            Powerful Features for 
                            <span class="gradient-text">Modern Teams</span>
                        </h2>
                        <p class="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto leading-relaxed">
                            Discover how JigsAI transforms the way you work with cutting-edge AI technology 
                            designed for productivity and efficiency.
                        </p>
                    </div>

                    <!-- Features Grid -->
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
                        ${this.features.map(feature => html`
                            <feature-card
                                icon="${feature.icon}"
                                title="${feature.title}"
                                description="${feature.description}">
                            </feature-card>
                        `)}
                    </div>

                    <!-- Additional CTA -->
                    <div class="text-center mt-16">
                        <p class="text-lg text-gray-600 dark:text-gray-400 mb-6">
                            Ready to experience the future of automation?
                        </p>
                        <sl-button
                            variant="primary"
                            size="large"
                            @click="${this.handleExploreFeatures}">
                            <sl-icon slot="prefix" library="fa-solid" name="fa-arrow-right"></sl-icon>
                            Explore All Features
                        </sl-button>
                    </div>
                </div>
            </section>
        `
    }

    handleExploreFeatures() {
        // Navigate to detailed features page or scroll to next section
        document.querySelector('about-section')?.scrollIntoView({ 
            behavior: 'smooth' 
        })
    }
}

customElements.define('features-section', FeaturesSection)